import { t } from "i18next";
import { Trans } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import { ChatbotStateContext } from "../utils/chatbotContext";
import { faRefresh } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "../../ui/components/Button";
import { useWebSocketContext } from "../utils/chatbotWSContext";

export const ChatbotNotifications = () => {

  const chatbotCurrentState = useContext(ChatbotStateContext);
  const { connect } = useWebSocketContext();
  const [mssg, setMssg] = useState("Coming Soon");

  useEffect(() => {
    const currentState = chatbotCurrentState.currentState;
    if (currentState === "Connecting State") {
      setMssg("Connecting...");
    }
    else if (currentState === "Session Timeout State") {
      setMssg("Session Timeout");
    } else if (currentState === "Error Connecting State") {
      setMssg("Connecting...");
      setTimeout(() => {
        // Wait for a second, before going from connection fail - connected
        setMssg("Wingman is currently unavailable. Please check back shortly.");
      }, 1000);
    } else if (currentState === "Connected State") {
      setMssg("Connected");
    }
  }, [chatbotCurrentState.currentState]);

  const handleReconnect = () => {
    connect(chatbotCurrentState.selectedBrand, chatbotCurrentState.selectedRole);
  };

  return (
    <div className="flex flex-grow flex-col items-center justify-center overflow-auto z-30">
      <img src={"/UB-Wingman-AI-Logo.png"} className="h-40 pointer-events-none user-select-none" alt="command-center" />
      <div className="text-xl font-unleashed"><Trans>Welcome</Trans></div>
      <p className="mt-3 text-ua-pink text-xl">{mssg}</p>
      {mssg === "Session Timeout" && (
        <Button type="button" title={t`Reconnect`} className="mx-auto mt-5" onClick={handleReconnect}>
          <FontAwesomeIcon icon={faRefresh} />
          <span className="ml-2"><Trans>Reconnect</Trans></span>
        </Button>
      )}
    </div>
  );
};
